<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

/** Markdown-it + breaks:true often ends blocks with <br>; trim so bubbles don’t get a ghost line */
const stripTrailingBrParagraphs = html => {
  if (typeof html !== 'string') return html;
  let h = html.trimEnd();
  let prev;
  do {
    prev = h;
    h = h.replace(/(?:<br\s*\/?>\s*)+(<\/p>\s*)$/i, '$1');
  } while (h !== prev);
  h = h.replace(/(?:<p>\s*<\/p>\s*)+$/gi, '');
  return h.trimEnd();
};

const formattedContent = computed(() => {
  const raw =
    typeof props.content === 'string'
      ? props.content.replace(/(?:\r?\n)+$/u, '')
      : props.content;

  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return raw;
  }

  let html = new MessageFormatter(raw).formattedMessage;
  if (typeof html === 'string') {
    html = html
      .replace(/<p>\s*(?:<br\s*\/?>\s*)*\s*<\/p>/gi, '')
      .replace(/(?:<br\s*\/?>\s*)+(?=<\/p>)/gi, '');
    html = stripTrailingBrParagraphs(html);
  }
  return html;
});
</script>

<template>
  <div
    v-dompurify-html="formattedContent"
    class="prose prose-bubble !my-0 min-h-0 max-w-none whitespace-normal break-words [&_li]:leading-[inherit] [&_p]:!m-0 [&_p:last-child]:!mb-0 [&_pre]:whitespace-pre"
  />
</template>
